import {dataHooks} from '@wix/data-hooks'

export const cancelModalDataHooks = dataHooks<{
  feeNotice: {}
  viewPolicyLink: {}
}>('cancel-modal')
